// extracted by mini-css-extract-plugin
export default {"Picture":"Picture_Hqzf6","isFallback":"isFallback_HIwqg","Picture_asset":"Picture_asset_xyApQ","Picture___cover":"Picture___cover_ENkmH"};